const SaferHomeEnvironmentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M52.9516 63.9997H11.1776C10.7146 63.9997 10.3394 63.6244 10.3394 63.1615V21.7679C10.3394 21.305 10.7146 20.9297 11.1776 20.9297C11.6405 20.9297 12.0158 21.305 12.0158 21.7679V62.3233H52.1134V21.7679C52.1134 21.305 52.4887 20.9297 52.9516 20.9297C53.4146 20.9297 53.7899 21.305 53.7899 21.7679V63.1615C53.7899 63.6244 53.4146 63.9997 52.9516 63.9997Z"
        fill="#027C80"
      />
      <path
        d="M60.3425 29.9285C60.128 29.9285 59.9135 29.8467 59.7498 29.6831L32.0904 2.02356L4.43098 29.6831C4.10355 30.0103 3.57293 30.0103 3.2455 29.6831C2.91817 29.3557 2.91817 28.8249 3.2455 28.4976L31.4977 0.245427C31.8251 -0.0818089 32.3557 -0.0818089 32.6831 0.245427L60.9353 28.4976C61.2626 28.8249 61.2626 29.3557 60.9353 29.6831C60.7716 29.8467 60.5571 29.9285 60.3425 29.9285Z"
        fill="#027C80"
      />
      <path
        d="M28.6881 43.9581C28.4736 43.9581 28.2591 43.8762 28.0954 43.7126L24.496 40.1132C24.1687 39.7859 24.1687 39.2551 24.496 38.9277C24.8234 38.6005 25.354 38.6005 25.6815 38.9277L28.6881 41.9345L38.4005 32.222C38.7279 31.8948 39.2586 31.8948 39.586 32.222C39.9133 32.5493 39.9133 33.0801 39.586 33.4075L29.2809 43.7126C29.1172 43.8762 28.9027 43.9581 28.6881 43.9581Z"
        fill="#FFA473"
      />
      <path
        d="M32.0905 52.2669C24.1788 52.2669 17.7422 45.8302 17.7422 37.9186C17.7422 30.007 24.1788 23.5703 32.0905 23.5703C40.0021 23.5703 46.4388 30.007 46.4388 37.9186C46.4388 45.8302 40.0021 52.2669 32.0905 52.2669ZM32.0905 25.2467C25.1032 25.2467 19.4186 30.9313 19.4186 37.9186C19.4186 44.9059 25.1032 50.5905 32.0905 50.5905C39.0778 50.5905 44.7623 44.9059 44.7623 37.9186C44.7623 30.9313 39.0778 25.2467 32.0905 25.2467Z"
        fill="#06AEB3"
      />
    </svg>
  );
};

export default SaferHomeEnvironmentIcon;
